import calculatorVacanciesButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/calculator_vacancies_button_click';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Link } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { professionAreaIdToAreaEnumMap } from 'src/fixtures/areas';
import { AreaEnum } from 'src/types/area';
import pluralize from 'src/utils/pluralize';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.calculator.tablo.vacancies.title',
    count: 'career-platform.profession.sections.calculator.tablo.vacancies.count',
    link: 'career-platform.profession.sections.calculator.tablo.vacancies.link',
    vacancy: {
        one: 'career-platform.pluralize.vacancy.one',
        some: 'career-platform.pluralize.vacancy.some',
        many: 'career-platform.pluralize.vacancy.many',
    },
};

interface Props {
    init: boolean;
    count: number;
    link: string;
}

const ItemVacancies: TranslatedComponent<Props> = ({ trls, init, count, link }) => {
    const { professionId, currentGrade, currentRegion } = useSelectorNonNullable((state) => state.pageProfession);
    const handleClick = () => {
        calculatorVacanciesButtonClick({
            professionId,
            areaName: professionAreaIdToAreaEnumMap[currentRegion] || AreaEnum.LOCAL,
            levelId: currentGrade?.id!, // eslint-disable-line @typescript-eslint/no-non-null-asserted-optional-chain
        });
    };
    return (
        <>
            {init && <p className={styles.itemDescription}>{trls[TrlKeys.title]}</p>}
            {!init && (
                <div className={styles.itemVacanciesContainer}>
                    <p className={styles.itemHeading} data-qa="calculator-tablo-vacancies">
                        {pluralize({
                            count,
                            one: trls[TrlKeys.vacancy.one],
                            some: trls[TrlKeys.vacancy.some],
                            many: trls[TrlKeys.vacancy.many],
                            useCount: true,
                        })}
                    </p>
                    <div className={styles.itemVacanciesLink}>
                        <Link
                            href={link}
                            onClick={handleClick}
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            typography="label-3-regular"
                        >
                            {trls[TrlKeys.link]}
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
};

export default translation(ItemVacancies);
